import { render } from "./InputPhone.vue?vue&type=template&id=9cac71da&ts=true"
import script from "./InputPhone.vue?vue&type=script&lang=ts"
export * from "./InputPhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__